import { render, staticRenderFns } from "./CompaniaEntradas.vue?vue&type=template&id=0a9181b8"
import script from "./CompaniaEntradas.vue?vue&type=script&lang=js"
export * from "./CompaniaEntradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports